import { render, staticRenderFns } from "./backgroundDetailLeave.vue?vue&type=template&id=428fc53a&"
import script from "./backgroundDetailLeave.vue?vue&type=script&lang=js&"
export * from "./backgroundDetailLeave.vue?vue&type=script&lang=js&"
import style0 from "./backgroundDetailLeave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports